import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const WholesaleManage: AppRouteModule = {
  path: '/wholesaleManage',
  name: 'WholesaleManage',
  identify: 'wholesaleManage',
  component: LAYOUT,
  redirect: '/wholesaleManage/wholesaleOrder',
  meta: {
    icon: 'ant-design:transaction-outlined',
    title: '配销管理',
    orderNo: 1,
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    // 配销订单
    {
      path: 'wholesaleOrder',
      name: 'WholesaleOrder',
      identify: 'wholesaleOrder',
      component: () => import('@/views/wholesaleManage/wholesaleOrder/index.vue'),
      meta: {
        title: '配销订单',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 新建配销单
    {
      path: 'wholesaleOrder/add',
      name: 'WholesaleOrderAdd',
      identify: 'wholesaleOrder',
      component: () => import('@/views/wholesaleManage/wholesaleOrder/add.vue'),
      meta: {
        title: '新建配销单',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/wholesaleManage/wholesaleOrder',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 配销退货
    {
      path: 'wholesaleReturn',
      name: 'WholesaleReturn',
      component: () => import('@/views/wholesaleManage/wholesaleReturn/index.vue'),
      identify: 'wholesaleReturn',
      meta: {
        title: '配销退货',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 新建销退单
    {
      path: 'wholesaleReturn/add',
      name: 'WholesaleReturnAdd',
      identify: 'wholesaleReturn',
      component: () => import('@/views/wholesaleManage/wholesaleReturn/add.vue'),
      meta: {
        title: '新建销退单',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/wholesaleManage/wholesaleReturn',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 调拨管理
    {
      path: 'allocationManage',
      name: 'AllocationManage',
      component: () => import('@/views/wholesaleManage/allocationManage/index.vue'),
      identify: 'allocationManage',
      meta: {
        title: '调货管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'allocationManage/:type/:transfer_num?',
      name: 'AllocationManageAdd',
      component: () => import('@/views/wholesaleManage/allocationManage/add.vue'),
      identify: 'allocationManage',
      meta: {
        title: '新建调货单',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/wholesaleManage/allocationManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default WholesaleManage;
